import styled from "@emotion/styled";
import { colors } from "src/theme";

export const InputStyle = styled.input((props: { 
  hasError: boolean, 
  colors?: { 
    background?: string, 
    text?: string,
    disabledBackground?: string,
    disabledText?: string
  },
  disabled?: boolean
}) => {
  const customColors = {
    background: colors.background7,
    text: colors.text3,
    disabledBackground: colors.background5,
    disabledText: colors.text3,
    ...props.colors
  };

  return {
    boxSizing: 'border-box' as const,
    outline: 'none',
    display: 'block',
    width: '100%',
    //height: '44px',
    padding: '10px 16px',
    fontSize: '18px',
    fontWeight: 400,
    fontStyle: 'normal',
    fontFamily: "Red Hat Display",
    lineHeight: '24px',
    color: props.disabled ? customColors.disabledText : customColors.text,
    backgroundColor: props.disabled ? customColors.disabledBackground : customColors.background,
    borderRadius: '8px',
    border: `1px solid ${props.hasError ? colors.error1 : colors.border5}`,
    transition: 'border-color .15s ease-in-out, box-shadow .15s ease-in-out',

    '&[disabled]': {
      border: `1px solid ${colors.border5}`,
      color: colors.text2,
      pointerEvents: 'none' as const,
    },

    '&::-moz-placeholder': {
      color: colors.text4,
      opacity: 1,
    },

    '&:-ms-input-placeholder': {
      color: colors.text4,
    },

    '&::-webkit-input-placeholder': {
      color: colors.text4,
    },

    '&:focus::-moz-placeholder': {
      color: 'transparent',
      opacity: 1,
    },

    '&:focus:-ms-input-placeholder': {
      color: 'transparent',
    },

    '&:focus::-webkit-input-placeholder': {
      color: 'transparent',
    },

    '&:focus': {
      borderColor: colors.border4,
    },

    '&:focus-visible': {
      outline: `2px solid ${colors.primary}`,
      outlineOffset: '2px',
    },

    '&[type=number]::-webkit-inner-spin-button, &[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none' as const,
      MozAppearance: 'none' as const,
      appearance: 'none' as const,
    },
  }
});